import { TreeNodeModel } from './TreeSelect.types';

export const mapToParentMap = (data: TreeNodeModel[]): Record<string, string[]> => {
  return data.reduce((acc: Record<string, string[]>, item) => {
    return goThroughAllNodes(item, acc);
  }, {});
};

export const filterData = (data: TreeNodeModel[], searchValue: string): TreeNodeModel[] => {
  const filterNodes = (result, current) => {
    if (nodeMatchesSearchCriteria(current, searchValue)) {
      const withFilteredChildren = {
        ...current,
        children: current.children ? current.children.reduce(filterNodes, []) : undefined,
      };
      result.push(withFilteredChildren);
      return result;
    }
    if (current.children) {
      const nodes = current.children.reduce(filterNodes, []);
      if (nodes.length) {
        result.push({ ...current, children: nodes });
      }
    }
    return result;
  };

  return data.reduce(filterNodes, []);
};

export const getParentKeys = (data: TreeNodeModel[], parentKeys: string[] = []): string[] => {
  data.forEach((node) => {
    if (node.children) {
      parentKeys.push(node.key);
      getParentKeys(node.children, parentKeys);
    }
  });
  return parentKeys;
};

export const getChildNodesToToggle = (
  nodes: TreeNodeModel[],
  id: string
): { childNodesToToggle: string[]; path: string[] } => {
  const array: string[] = [];
  const path: string[] = [];

  const nodeToToggle = getNodeById(nodes, id, path)!;
  return { childNodesToToggle: getAllChild(nodeToToggle, array), path };
};

export const getNodeById = (nodes: TreeNodeModel[], id: string, parentsPath: string[] = []): TreeNodeModel | null => {
  for (const node of nodes) {
    const result = searchBranch(node, id, parentsPath);
    if (result) {
      return result;
    }
  }
  return null;
};

const nodeMatchesSearchCriteria = (node: TreeNodeModel, searchValue: string) =>
  node.title.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;

const goThroughAllNodes = (node: TreeNodeModel, map: Record<string, string[]> = {}) => {
  if (!node.children) {
    return map;
  }

  // eslint-disable-next-line no-param-reassign
  map[node.key] = getAllChild(node).splice(1);

  for (const childNode of node.children) {
    goThroughAllNodes(childNode, map);
  }
  return map;
};

const getAllChild = (childNode: TreeNodeModel | null, collectedNodes: string[] = []) => {
  if (childNode === null) return collectedNodes;

  collectedNodes.push(childNode.key);

  if (Array.isArray(childNode.children)) {
    for (const node of childNode.children) {
      getAllChild(node, collectedNodes);
    }
  }

  return collectedNodes;
};

const searchBranch = (node: TreeNodeModel, id: string, parentsPath: string[]) => {
  let result: TreeNodeModel | null = null;
  if (node.key === id) {
    return node;
  }
  if (Array.isArray(node.children)) {
    for (const childNode of node.children) {
      result = searchBranch(childNode, id, parentsPath);

      if (result) {
        parentsPath.push(node.key);
        return result;
      }
    }

    return result;
  }
  return result;
};
